module.exports = __webpack_public_path__ + "static/media/29COICT3.7ed820b1.jpg";